import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";

/**
 * Invalidates the visits list and the visitor queries built from visits
 * (directory and history). Use after changing a visit, e.g. a check-out.
 */
export const useInvalidateVisits = () => {
  const queryClient = useQueryClient();

  return useCallback(async () => {
    await queryClient.invalidateQueries({ queryKey: ["visits.list"] });
    await queryClient.invalidateQueries({ queryKey: ["visitors.list"] });
    await queryClient.invalidateQueries({ queryKey: ["visitors.get"] });
  }, [queryClient]);
};
